/**
 * App 主线包列表页面
 */

import React from 'react'
import { APP_LIST } from './constants'
import PureList from 'pureComponents/PureList'
import SplitView from 'pureComponents/SplitView'
import useAppList from './hooks/useAppList'
function AppList() {
    const { colRender, state, setState, setSplitViewInstance, handleAddButtonClick } = useAppList()
    return (
        <>
            <PureList
                columnsConfig={APP_LIST}
                colRender={colRender}
                showAddBtn={true}
                showFilter={false}
                showPageBar={false}
                handleAddButtonClick={handleAddButtonClick}
                {...state}
                {...setState}
            />
            <SplitView ref={setSplitViewInstance} />
        </>
    )
}

export default AppList
